module.exports = __webpack_public_path__ + "img/02.4a3ab34a.jpg";